import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58810713")

_pushScopeId("data-v-58810713")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = {
  key: 0,
  class: "absence-admin-view"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-times" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-check" })
], -1)
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon = _resolveComponent("icon")
  const _component_comment_teleport = _resolveComponent("comment-teleport")

  return (_openBlock(), _createBlock("td", {
    class: ["day", { 'day--not-business': !_ctx.day?.businessDay }],
    height: "35",
    onMouseenter: _cache[3] || (_cache[3] = () => (_ctx.isCommentHover = true)),
    onMouseleave: _cache[4] || (_cache[4] = () => (_ctx.isCommentHover = false)),
    title: _ctx.day?.periods.split(',').join(', ')
  }, [
    (_ctx.day && _ctx.dayNotFilled(_ctx.day))
      ? (_openBlock(), _createBlock("span", _hoisted_1, [
          _createVNode(_component_icon, { name: "kaktus" })
        ]))
      : (_openBlock(), _createBlock("span", _hoisted_2, [
          (_ctx.day?.unpaid && _ctx.day?.notAvailableAccepted)
            ? (_openBlock(), _createBlock("span", _hoisted_3, [
                _createVNode(_component_icon, {
                  name: "not-available",
                  title: "Unpaid absence"
                }),
                _createVNode(_component_icon, {
                  name: "thunder",
                  title: "Unpaid absence"
                })
              ]))
            : (_ctx.day?.occasionalAbsence && _ctx.day?.notAvailableAccepted)
              ? (_openBlock(), _createBlock("span", _hoisted_4, [
                  _createVNode(_component_icon, {
                    name: "not-available",
                    title: "Special absence"
                  }),
                  _createVNode(_component_icon, {
                    name: "occasional-absence",
                    title: "Special absence"
                  })
                ]))
              : (_ctx.day?.atConference)
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    _createVNode(_component_icon, { name: "course" })
                  ]))
                : (
          _ctx.day?.notAvailable &&
          (_ctx.day?.notAvailableAccepted || _ctx.day?.markedByPartTimeUser)
        )
                  ? (_openBlock(), _createBlock("span", _hoisted_6, [
                      _createVNode(_component_icon, { name: "not-available" })
                    ]))
                  : _createCommentVNode("", true),
          (_ctx.day?.halfNotAvailable)
            ? (_openBlock(), _createBlock("span", _hoisted_7, [
                _createVNode(_component_icon, {
                  name: "half-day",
                  title: _ctx.halfDayAbsenceMsg(_ctx.day)
                }, null, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shouldDisplayQuestionMark(_ctx.day))
            ? (_openBlock(), _createBlock("span", _hoisted_8, [
                (_ctx.isUserAdmin)
                  ? (_openBlock(), _createBlock("span", _hoisted_9, [
                      _createVNode("button", {
                        class: ["button is-small is-outlined is-danger", { 'is-loading': _ctx.isAbsenceAcceptationLoading }],
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.declineAbsence(_ctx.day)))
                      }, [
                        _hoisted_10
                      ], 2),
                      _createVNode("button", {
                        class: ["button is-small is-outlined is-success", { 'is-loading': _ctx.isAbsenceAcceptationLoading }],
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptAbsence(_ctx.day)))
                      }, [
                        _hoisted_11
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_icon, { name: "absence-in-review" })
              ]))
            : (_ctx.day?.businessDay && !_ctx.anyUnavailabilityWasMarked(_ctx.day))
              ? (_openBlock(), _createBlock("span", _hoisted_12, [
                  _createVNode(_component_icon, {
                    name: _ctx.day.remote ? 'remote' : 'office'
                  }, null, 8, ["name"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.cellInfo), 1)
                ]))
              : _createCommentVNode("", true),
          (_ctx.day?.comment || _ctx.day?.halfNotAvailableStartTime)
            ? (_openBlock(), _createBlock("span", _hoisted_13, [
                (_ctx.day.comment)
                  ? (_openBlock(), _createBlock(_component_icon, {
                      key: 0,
                      name: "comment"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.user)
                  ? (_openBlock(), _createBlock(_component_comment_teleport, {
                      key: 1,
                      user: _ctx.user,
                      day: _ctx.day,
                      "is-active": _ctx.isCommentHover
                    }, null, 8, ["user", "day", "is-active"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 42, ["title"]))
})